import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { WorkstepContent } from '../../ticket-detail/workstep-content/workstep-content.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cu-main',
  templateUrl: './cu-main.component.html',
  styleUrls: ['./cu-main.component.scss'],
})
export class CuMainComponent implements OnInit {

  @Input() contentScrollEvent: EventEmitter<any>
  public isContentLoading: boolean = false
  public searchValue: string = ""
  public contentOnEditID: number;
  private scrollSub: Subscription

  constructor(
    public ticketSrv: TicketCustomer.TicketService,
    private feedback: FeedbackService
  ) { }

  ngOnInit() {
    this.scrollSub = this.contentScrollEvent.asObservable().subscribe(async (event: any)=>{
        this.ticketSrv.contentOffset+=25
        await this.ticketSrv.setWorkstepContent(this.ticketSrv.activeWorkstepId, this.searchValue)
    })
  }

  ngOnDestroy(){
    this.scrollSub?.unsubscribe()
  }

  public get isDesktop(): boolean{
    return window.matchMedia("(min-width: 1050px)").matches
  }

  private contentSearchTimeout:any
  public async searchWorkstepContent(){
    this.isContentLoading = true
    clearTimeout(this.contentSearchTimeout)
    this.contentSearchTimeout = setTimeout(async () => {
      await this.ticketSrv.setWorkstepContent(this.ticketSrv.activeWorkstepId, this.searchValue)
      this.isContentLoading = false
    }, 300);
  }

  public addWorkstepContent(){
    this.ticketSrv.workstepContentsOnEdit.push({
      id: null,
      workstepId: this.ticketSrv.activeWorkstep.id,
      htmlText: ""
    })
  }

  public workstepContentClosed(data: WorkstepContent){
    if(data === undefined) return
    this.ticketSrv.workstepContentsOnEdit.splice(this.ticketSrv.workstepContentsOnEdit.findIndex(s => s.workstepId == this.ticketSrv.activeWorkstepId),1)
  }

  public async onWorkstepContentEdit(event: WorkstepContent){
    if(event === undefined) return
    if(event === null) this.contentOnEditID = -1
    else{
        if(this.ticketSrv.hasWorkstepContentEditValue){
          if(!(await this.feedback.confirm("Sie sind gerade dabei einen neuen Eintrag zu erstellen. Möchten Sie diesen verwerfen?", "Verwerfen", "Abbrechen"))) return
          this.ticketSrv.workstepContentsOnEdit.splice(this.ticketSrv.workstepContentsOnEdit.findIndex(s => s.workstepId == this.ticketSrv.activeWorkstepId),1)
        }
        this.contentOnEditID = event.id
    }
  }

}
